<template>
  <RevForm
    autocomplete="off"
    :initial-values
    :validate="validate()"
    @submit="(values) => emit('submit', values)"
  >
    <template #default="{ values, errors }">
      <div class="space-y-20">
        <AttachmentsUpload v-model="values.attachments">
          <template #default="{ addAttachments }">
            <div class="space-y-4">
              <div class="flex items-center gap-12">
                <div class="grow">
                  <RevInputTextarea
                    id="message"
                    v-model="values.message"
                    class="grow"
                    :class="{
                      '!border-action-danger-low': Boolean(errors.message),
                    }"
                    :label="i18n(translations.inputLabel)"
                    :max-rows="8"
                  />
                </div>
                <RevButtonIcon
                  :icon="IconAttachment"
                  variant="primary"
                  @click="addAttachments"
                />
              </div>
              <div v-if="errors.message" class="text-static-danger-hi mt-8">
                {{ errors.message }}
              </div>
            </div>
          </template>
        </AttachmentsUpload>

        <div class="flex items-center gap-16">
          <NextTaskCheckbox
            v-if="hasNextTask"
            v-model="values.isNextTaskChecked"
          />
          <RevButton
            :disabled="isLoading"
            :loading="isLoading"
            type="submit"
            variant="primary"
          >
            {{ i18n(translations.submit) }}
          </RevButton>
        </div>
      </div>
    </template>
  </RevForm>
</template>

<script setup lang="ts">
import { computed, reactive } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevForm, makeValidate, required } from '@ds/components/Form'
import { RevInputTextarea } from '@ds/components/InputTextarea'
import { IconAttachment } from '@ds/icons/IconAttachment'

import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'

import AttachmentsUpload from '../AttachmentsUpload/AttachmentsUpload.vue'
import NextTaskCheckbox from '../NextTaskCheckbox/NextTaskCheckbox.vue'

import translations from './MessageForm.translations'

const { mostUrgentTask } = defineProps<{
  isLoading: boolean
  mostUrgentTask?: OrderlineOpenTask
}>()

const i18n = useI18n()
const emit = defineEmits(['submit'])

const hasNextTask = computed(() => Boolean(mostUrgentTask))

type FormValues = {
  message: ''
  attachments: File[]
  isNextTaskChecked: boolean
}

const initialValues = reactive<FormValues>({
  message: '',
  attachments: [],
  isNextTaskChecked: hasNextTask.value,
})

function validate() {
  return makeValidate<FormValues>({
    message: [required(i18n(translations.requiredMessageError))],
  })
}
</script>
